var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 45,
    height: 45,
    rx: 2,
    fill: "#F2EDF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0339 10.7948C23.0339 10.4346 23.3259 10.1426 23.6861 10.1426H37.8479C38.2081 10.1426 38.5001 10.4346 38.5001 10.7948V35.2053C38.5001 35.5655 38.2081 35.8575 37.8479 35.8575H23.6861C23.3259 35.8575 23.0339 35.5655 23.0339 35.2053C23.0339 34.8451 23.3259 34.5532 23.6861 34.5532H37.1957V11.447H23.6861C23.3259 11.447 23.0339 11.155 23.0339 10.7948Z",
    fill: "#773DBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1055 31.2923C24.1055 30.9321 24.3975 30.6401 24.7577 30.6401H33.9815C34.3417 30.6401 34.6337 30.9321 34.6337 31.2923C34.6337 31.6525 34.3417 31.9445 33.9815 31.9445H24.7577C24.3975 31.9445 24.1055 31.6525 24.1055 31.2923Z",
    fill: "#773DBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1055 27.0999C24.1055 26.7397 24.3975 26.4478 24.7577 26.4478H33.9815C34.3417 26.4478 34.6337 26.7397 34.6337 27.0999C34.6337 27.4601 34.3417 27.7521 33.9815 27.7521H24.7577C24.3975 27.7521 24.1055 27.4601 24.1055 27.0999Z",
    fill: "#773DBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1055 22.9071C24.1055 22.5469 24.3975 22.2549 24.7577 22.2549H33.9815C34.3417 22.2549 34.6337 22.5469 34.6337 22.9071C34.6337 23.2673 34.3417 23.5593 33.9815 23.5593H24.7577C24.3975 23.5593 24.1055 23.2673 24.1055 22.9071Z",
    fill: "#773DBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1055 18.7142C24.1055 18.354 24.3975 18.062 24.7577 18.062H33.9815C34.3417 18.062 34.6337 18.354 34.6337 18.7142C34.6337 19.0744 34.3417 19.3664 33.9815 19.3664H24.7577C24.3975 19.3664 24.1055 19.0744 24.1055 18.7142Z",
    fill: "#773DBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1055 14.5218C24.1055 14.1616 24.3975 13.8696 24.7577 13.8696H33.9815C34.3417 13.8696 34.6337 14.1616 34.6337 14.5218C34.6337 14.882 34.3417 15.174 33.9815 15.174H24.7577C24.3975 15.174 24.1055 14.882 24.1055 14.5218Z",
    fill: "#773DBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.221 7.6487L6.93343 10.8079C6.67998 10.8542 6.49585 11.075 6.49585 11.3326V34.2123C6.49585 34.4651 6.67319 34.6831 6.92063 34.7346L24.2082 38.3325C24.5394 38.4015 24.8504 38.1486 24.8504 37.8102V8.17349C24.8504 7.84046 24.5486 7.58884 24.221 7.6487Z",
    fill: "#773DBD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8058 17.6156H9.25604C9.04019 17.6156 8.87851 17.8134 8.92143 18.0249L11.0336 28.4347C11.0659 28.5939 11.2058 28.7083 11.3682 28.7083H13.0161C13.1744 28.7083 13.3119 28.5995 13.3483 28.4454L15.0546 21.2328L16.4479 28.4317C16.479 28.5923 16.6196 28.7083 16.7831 28.7083H18.8553C19.0144 28.7083 19.1525 28.5983 19.1881 28.4432L21.7375 17.3368C21.7866 17.1229 21.6242 16.9189 21.4048 16.9189H19.7019C19.5391 16.9189 19.399 17.0338 19.3671 17.1934L17.7875 25.0911L16.288 17.5156C16.2563 17.3557 16.116 17.2405 15.953 17.2405H14.3124C14.1514 17.2405 14.0123 17.3529 13.9786 17.5104L12.4288 24.7428L11.1414 17.8939C11.111 17.7325 10.9701 17.6156 10.8058 17.6156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocx);
export default __webpack_public_path__ + "static/media/ic_docx.7c6fc2b9a15dade72900ee20133c590f.svg";
export { ForwardRef as ReactComponent };